import type { CheckoutConfiguration } from "@jti/commerce";

export function getCheckoutModel(container: HTMLElement): CheckoutConfiguration {
  const stringifiedModel = container.dataset.desAppModel || "";

  try {
    return JSON.parse(stringifiedModel) as CheckoutConfiguration;
  } catch (e) {
    console.error(e);
    return {} as CheckoutConfiguration;
  }
}
